import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { RENEW_MEETING } from 'store/eventConstants';
import { BROADCAST_CREATE_MEETING } from 'actions/Types';
import { getBroadcastRouteMatch } from 'actions/utils';
import {
  getStreamingStatus,
  getRecordingStatus
} from '@shoflo/studio-redux/utils';

/**
 * When a meeting ends unexpectedly and a stream is going on,
 * we want to pass the stream or recording the new meeting instance,
 * Once the user loads and the previous meeting is inactive, it creates a new meeting
 * and returns a new meeting Id, if the previous meeting is still active, given the params
 * it will attempt to create a meeting but return the meetingId of the previous meeting
 * @param {*} socket
 * @returns
 */
const renewMeetingStream = socket => store => next => action => {
  from([action])
    .pipe(
      filter($action => $action.type === `${BROADCAST_CREATE_MEETING}_SUCCESS`)
    )
    .subscribe(async () => {
      /** Check if there is an ongoing recording or stream */
      const {
        broadcastRecordings: { liveRecordings },
        broadcastStreamEndpoints: streamEndpoints,
        broadcast
      } = store.getState();

      /** Check the new meeting response */
      const { meetingResponse } = action.payload;

      /** Check for active recording/streaming */
      const isRecording = getRecordingStatus(liveRecordings);
      const isStreaming = getStreamingStatus(streamEndpoints);

      if (!isRecording && !isStreaming) return;

      const routeMatch = getBroadcastRouteMatch(store.getState);

      if (!routeMatch) return;

      const {
        params: { broadcastId }
      } = routeMatch;

      /** Create meeting will return the same meeting ID if it is valid and a different meeting Id if the previous ID is inactive */
      const isMeetingChanged =
        broadcast.meetingId !== meetingResponse.Meeting.MeetingId;

      /** Only run this when last meeting ended or inactive and there is an active stream and/or recording */
      if (isMeetingChanged && (isRecording || isStreaming)) {
        socket.emit(RENEW_MEETING, { meetingResponse, broadcastId });
      }
    });

  return next(action);
};

export default renewMeetingStream;
